import type { TAbTestKey } from 'constants/ab-tests'
import type { TRemoteConfigVariantData } from 'helpers/getRemoteConfigVariantData'
import { CurrentEnvironment } from 'root-constants'

const areAbTestOverridesEnabled = (): boolean =>
  import.meta.env.CURRENT_ENV !== CurrentEnvironment.PROD

// Non-prod QA: ?abtest_web_238_gbp_pricing=abtest_web_238_b_gbp_price
export const getAbTestOverridesFromSearch = (
  search: string,
  allowedKeys: TAbTestKey[],
): TRemoteConfigVariantData => {
  if (!areAbTestOverridesEnabled() || !search || !allowedKeys.length) {
    return {}
  }

  const searchParams = new URLSearchParams(search)

  return Object.fromEntries(
    allowedKeys.flatMap((key) => {
      const value = searchParams.get(key)?.trim()

      if (!value) {
        return []
      }

      return [[key, { value, sendAnalytics: true }]]
    }),
  )
}
